// src/apiConfig.js
const API_BASE_URL = process.env.VUE_APP_API_URL;

export const API_ENDPOINTS = {
    // Company APIs
    fetchAllCompanies: `${API_BASE_URL}/view-company/company-data-short/{companyId}/{archiveStatus}`,
    fetchCompanyById: `${API_BASE_URL}/view-company/company/{companyId}`,
    createNewCompany: `${API_BASE_URL}/create-company/insert`,

    // Employee APIs
    fetchAllEmployees: `${API_BASE_URL}/view-employees/employees-data-short/{employeeId}/{companyId}/{archiveStatus}`,
    searchEmployees: `${API_BASE_URL}/view-employees/search`,
    fetchActiveEmployeeStructures: `${API_BASE_URL}/view-employees/active-structure-categories`,
    fetchEmployeeById: `${API_BASE_URL}/view-employees/employee/{employeeId}`,
    createNewEmployee: `${API_BASE_URL}/create-employee/insert`,
    updateEmployee: `${API_BASE_URL}/update-employee/update`,
    createEmployee: `${API_BASE_URL}/create-employee/create`,

    // Rosters APIs
    fetchRosters: `${API_BASE_URL}/view-roster/roster-data/{employeeId}/{companyId}/{startDate}/{endDate}`,
    searchRosters: `${API_BASE_URL}/view-roster/roster-data/search`,
    fetchRostersBulkIds: `${API_BASE_URL}/view-roster/bulk-view-roster/{rosterIds}`,
    fetchRostersSingle: `${API_BASE_URL}/view-roster/view-last-roster/{employeeId}/{shiftType}`,
    deleteRoster: `${API_BASE_URL}/update-roster/delete-roster`,
    bulkDeleteRoster: `${API_BASE_URL}/update-roster/bulk-delete-roster`,
    bulkEditRoster: `${API_BASE_URL}/update-roster/bulk-update-roster`,
    createRoster: `${API_BASE_URL}/create-roster/insert`,
    createSingleRoster: `${API_BASE_URL}/create-roster/insert/single`,
    fetchSchedule: `${API_BASE_URL}/view-schedule/schedule-data/{companyId}/{startDate}/{endDate}`,

    // Leaves APIs
    fetchLeaves: `${API_BASE_URL}/view-leaves/leaves-data/{employeeId}/{companyId}/{startDate}/{endDate}`,
    searchLeaves: `${API_BASE_URL}/view-leaves/leaves-data/search`,
    searchLeavesCalendar: `${API_BASE_URL}/view-leaves/calendar-data/search`,
    searchCoverCalendar: `${API_BASE_URL}/view-roster/calendar-data/search`,

    // Attendance APIs
    fetchAttendance: `${API_BASE_URL}/view-attendance/attendance-data/{employeeId}/{companyId}/{startDate}/{endDate}`,
    searchAttendance: `${API_BASE_URL}/view-attendance/attendance-data/search`,
    fetchAttendanceSingle: `${API_BASE_URL}/view-attendance/attendance_single_entry/{employeeId}/{rosterId}/{attendanceId}`,
    fetchAttendanceBulk: `${API_BASE_URL}/view-attendance/bulk-attendance`,
    updateAttendanceCompanies: `${API_BASE_URL}/update-attendance/bulk-update-company`,
    reconcileAttendanceTimes: `${API_BASE_URL}/update-attendance/bulk-reconcile-time`,
    markRosterAttendance: `${API_BASE_URL}/create-attendance/mark-roster`,
    addAttendanceCheckout: `${API_BASE_URL}/create-attendance/add-checkout`,
    editAttendance: `${API_BASE_URL}/update-attendance/edit-attendance`,
    overtimeStaus: `${API_BASE_URL}/update-attendance/update-over-below-status`,
    deleteAttendance: `${API_BASE_URL}/update-attendance/delete-attendance`,
    clockIn: `${API_BASE_URL}/mark/kiosk/clockin`,
    clockOut: `${API_BASE_URL}/mark/kiosk/clockout`,

    // Dashboard
    fetchDashboardDay: `${API_BASE_URL}/view-roster/dashboard/{date}`,
    fetchOnlineEmployees: `${API_BASE_URL}/view-attendance/online-status`,

    // Insight APIs
    fetchInsightExpiringRosters: `${API_BASE_URL}/view-insight/expiring-roster`,
    fetchInsightUpcomingLeaves: `${API_BASE_URL}/view-insight/upcoming-leaves`,

    // Logs API
    fetchLogsById: `${API_BASE_URL}/view-logs/logs-by-id/{tableName}/{recordId}/{type}`,
    fetchLogs: `${API_BASE_URL}/view-logs/logs-data/{employeeId}/{companyId}/{section}/{startDate}/{endDate}/{userEmail}`,
    createLog: `${API_BASE_URL}/create-log/insert`,

    // Tickets APIs
    fetchTickets: `${API_BASE_URL}/view-tickets/all/{startDate}/{endDate}`,
    createTicket: `${API_BASE_URL}/create-ticket/insert`,
    updateTicket: `${API_BASE_URL}/update-ticket/update`,
    closeTicket: `${API_BASE_URL}/update-ticket/close-ticket`,
    reconcileTicket: `${API_BASE_URL}/update-ticket/reconcile-ticket`,
    fetchTicketById: `${API_BASE_URL}/view-tickets/{ticketId}/{employeeId}`,
    deletePost: `${API_BASE_URL}/update-ticket/delete-post`,
    deleteTicket: `${API_BASE_URL}/update-ticket/delete-ticket`,
    publishTicket: `${API_BASE_URL}/update-ticket/publish-ticket`,
}
